export default {
    achievement_locked: 'Ítem bloqueado',
    avatars: 'Avatares',
    books: 'Libros',
    buy_this_book: 'Comprar este libro',
    buy_this_pack: 'Comprar este pack',
    buy_this_skin: 'Comprar este skin',
    cost: 'cuesta:',
    favorites: 'Favoritos',
    next: 'Siguiente',
    of: ' de ',
    pack_of: 'Pack de',
    previous: 'Anterior',
    return: 'Volver',
    search: 'Buscar',
    skins: 'Skins',
    this_book: 'Este libro',
    this_pack: 'Este pack',
    this_skin: 'Este skin',
    you_have: 'Tienes',
}